import { useState } from "react";
import MapSelector from "./MapSelector";
import './Location.css';

const Location = ({ loadLocation, lat, lon, onLocationChange, locationResolved }) => {
  const [radius, setRadius] = useState(5);

  return (
    <div id='location' className='inner-container'>
      <div className='title'>Pick Location</div>

      <div className='bump-out'>
        {locationResolved ? (
          <MapSelector className='map' onLocationChange={onLocationChange} initLat={lat} initLon={lon} />
        ) : (
          <div className='title' style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px", width: "600px" }}>Loading map...</div>
        )}

        <div className='text'>
          Search Radius:{" "}
          <select value={radius} onChange={(e) => setRadius(Number(e.target.value))}>
            <option value={5}>5 miles</option>
            <option value={10}>10 miles</option>
            <option value={15}>15 miles</option>
          </select>
        </div>

        <div>
          <button className='button-74' type="button" onClick={() => loadLocation(lat, lon, radius)}>Next</button>
        </div>
      </div>
    </div>
  )
}

export default Location;